import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { LS } from 'src/app/helpers/localStorage.enum';
import { DataService } from 'src/app/services/data/data.service';
import { regexValidator } from 'src/app/helpers/customFormValidators';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.sass']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

  currentUser;
  token;

  resetForm = new FormGroup({
    newPassword: new FormControl('', [
      Validators.required,
      Validators.minLength(8),
      regexValidator(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\W])(?=.{8,})/),
      regexValidator(/^(?=.*[a-z])/, 'lowerRequired'),
      regexValidator(/^(?=.*[A-Z])/, 'upperRequired'),
      regexValidator(/^(?=.*[0-9])/, 'numberRequired'),
      regexValidator(/^(?=.*[\W])/, 'specialRequired')
    ]),
    checkPassword: new FormControl('')
  })

  submitClicked: boolean
  success: boolean = false
  logo = 'assets/images/aerodyne-outline-black.svg'

  public get newPassword() {
    return this.resetForm.get(resetForm.new)
  }

  get checkPassword() {
    return this.resetForm.get(resetForm.check)
  }

  get isFormValid() {
    return Object.keys(this.resetForm.controls).every(key => this.resetForm.controls[key].valid)
  }

  get isSuntory() {
    return location?.hostname.includes('suntory')
  }


  constructor(
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService,
    private activatedRouter: ActivatedRoute,
    private _t: TranslateService,
    private dataService: DataService,
  ) { }

  validateEnteredPassword(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {

      const isValid = control.value === this.newPassword.value

      return isValid ? null : { sameAsFirst: control.value }
    }
  }

  ngOnInit(): void {
    this.token = this.activatedRouter.snapshot.paramMap.get('id')
    this.auth.setPasswordResetToken(this.token).subscribe({
      next: (res) => {
        // localStorage.setItem(
        //   LS.currentUser,
        //   JSON.stringify({ user_id: res.id, username: res.username })

        // );
        this.dataService.setLocalStorage(
          LS.currentUser,
          JSON.stringify({ user_id: res.id, username: res.username })

        );
        this.logo = res?.organisation?.logo_url || this.logo
      },
      error: (err) => {
        this.router.navigate(['login'])
      }
    });

    this.checkPassword.setValidators([
      Validators.required,
      Validators.minLength(8),
      this.validateEnteredPassword()
    ])
    this.checkPassword.updateValueAndValidity()
  }

 submitForm() {
    if (this.resetForm.valid) {
      
      if (this.newPassword.value === this.checkPassword.value) {
        const newPass = this.newPassword.value
        this.auth.resetPassword(newPass, this.token).subscribe({
          next: (res) => {
            this.toastr.success(this._t.instant('Password Changed!'), this._t.instant('Success'))
            this.success = true
          },
          error: () => {
            this.toastr.error(this._t.instant('Failed to update password. Please check your network connection and try again'), this._t.instant('Error'))
          }
        });
      } else {
        this.toastr.error(this._t.instant('Password not match!'), this._t.instant('Error'))
        this.resetForm.reset()
      }
    } else {
      
    }
  }

  loginpage() {
    const currentUser = JSON.parse(localStorage.getItem(LS.currentUser));
    this.router.navigate(['login'], { queryParams: { username: currentUser.username } })
  }

  ngOnDestroy() {
    localStorage.removeItem('user');
  }

  useLanguage(language: string) {
    const currentUser = JSON.parse(localStorage.getItem(LS.currentUser));
    
    this._t.use(language)
    localStorage.setItem('def_lang', language)
  }

  // this.auth.resetpass({ email: this.resetForm.controls.newpassword.value }).subscribe({
  //   next: (response) => {
  //     this.success = true
  //   },
  //   error: (_) => {
  //     this.toastr.error('Password not match!', 'Error')
  //     this.resetForm.reset()
  //   }
  // })
  // }

}

enum resetForm {
  new = 'newPassword',
  check = 'checkPassword'
}
